import React, { useEffect, useState } from "react";
import { Button } from "devextreme-react/button";
import axios from "axios";

import {API_BASE_URL} from '../../../../config';

const PropertyBuildingsPreview = ({ propertyId, onManageBuildings }) => {
  const [buildings, setBuildings] = useState([]);

  const fetchBuildings = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}api/propertybuilding/${propertyId}`);
      setBuildings(res.data);
    } catch (err) {
      console.error("Error fetching buildings:", err);
    }
  };
  
    const optionKey = [
        { ID: '*', Name: 'County Owned', value:"County Owned - *" },
        { ID: '^', Name: 'County Maintained', value:"County Maintained - ^" },
        { ID: 'LM', Name: 'Leased Property ‑ Maintained by County', value:"Leased Property ‑ Maintained by County - LM" },
        { ID: 'LN', Name: 'Leased Property Non‑maintained', value:"Leased Property Non‑maintained – LN" },
        { ID: '0', Name: 'Zero Maintenance Responsibility', value:"Zero Maintenance Responsibility – 0" },
        { ID: 'CS', Name: 'Custodial Stewardship', value:"Custodial Stewardship - CS" },
    ]


  useEffect(() => {
    if (propertyId) fetchBuildings();
  }, [propertyId]);

  return (
    <div className="w-100">
      <Button
        text="Manage Buildings"
        type="default"
        onClick={() => onManageBuildings(propertyId)}
      />
    <div className='table-responsive snaptable'>
      
      <table className='table table-striped'>
        <thead>
          <tr>
            <th>Building ID/L #</th>
            <th>Key</th>
            <th>Description</th>
            <th>Building Location</th>
            <th>Ownership</th>
            <th>Building Sq Ft</th>
            <th>Building Acres</th>
          </tr>
        </thead>
        <tbody>
          {buildings.map((b) => (
            <tr key={b.buildingid}>
              <td className="info-record-value ">{b.bid}</td>
              <td className="info-record-value ">{b.pkey}</td>
              <td className="info-record-value ">{
                                                    optionKey.find(opt => opt.ID === b.pkey)?.Name || ""
                                                    }</td>
              <td className="info-record-value ">{b.buildinglocation}</td>              
              <td className="info-record-value ">{b.ownership}</td>
              <td className="info-record-value ">{b.buildingsf}</td>
              <td className="info-record-value ">{b.buildingacres}</td>
            </tr>
          ))}
        </tbody>
      </table>

      
    </div>
    </div>
  );
};

export default PropertyBuildingsPreview;
